import React, { useEffect, useState } from 'react';
import { Link, } from "react-router-dom";
import { faPlusSquare, faMinusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import service from '../services/anagrafica/Menuservice';
import Storage from './utils/Storage';
import { useLiveQuery } from 'dexie-react-hooks';
import db from '../db';

//riceve menu con
//- string label
//- [{label, url}] items elenco di voci
function BlockMenu({ id, vociPermesse, etichetta, titolo, aperto, pageUrl, onChangePageUrl }) {

    // eslint-disable-next-line no-unused-vars
    const [myShow, setMyShow] = useState(!!aperto);

    const toggleShow = () => setMyShow(!myShow);

    const isSuperUser = Storage.getItem('user_level') === 'S';

    return (
        <div className={'tmpl_menu_' + id}>
            {isSuperUser && (
                <>
                    {etichetta && <div className="mt-3 mb-3" style={{ cursor: 'pointer' }} onClick={toggleShow}>
                        {myShow ? <FontAwesomeIcon icon={faMinusSquare} /> : <FontAwesomeIcon icon={faPlusSquare} />}
                        <span className="pl-2" title={titolo || etichetta}>
                            {etichetta}
                        </span>
                    </div>}
                </>
            )}

            {myShow && !!vociPermesse && vociPermesse.length !== 0 && <ul className="list-group">
                {vociPermesse.map(({ url, etichetta, titolo }, index) => {
                    const itemActive = url === pageUrl;
                    return (
                        <Link
                            key={index}
                            className={'list-group-item voceMenu list-group-item-action p-3' + (itemActive ? ' font-weight-bold itemActive' : '')}
                            to={url}
                            onClick={() => onChangePageUrl(url)}
                            title={titolo}
                        >{etichetta}</Link>
                    )
                }
                )}
            </ul>}
        </div>
    );

}


//data: item menu, array di block menu
function Menu({ sezione }) {
    const langs = useLiveQuery(() => db.lingue.toArray());
    const [pageUrl, setPageUrl] = useState(window.location.pathname);
    const [data, setData] = useState([]);
    useEffect(() => {
        service.fullmenu({ sezione }).then(r => setData(r.data));
    }, [sezione]);
    if (data.length === 0) {
        return null;
    }

    const codice = langs && langs.length !== 0 ? langs[0].codice : null;
    
    const etichettaField = 'etichetta' + (codice ? codice.charAt(0).toUpperCase() + codice.slice(1) : '');

    const dataMap = item => {
        const { vociPermesse, ...myItem } = { ...item }
        myItem.etichetta = myItem[etichettaField] || myItem.etichettaIt;
        myItem.vociPermesse = vociPermesse.map(item => {
            const { ...myItem } = { ...item }
            myItem.etichetta = myItem[etichettaField] || myItem.etichettaIt;
            return myItem;
        });
        return myItem;
    }

    return (
        <>
            {data.map(dataMap).map((item, index) => <BlockMenu
                key={index}
                pageUrl={pageUrl}
                onChangePageUrl={setPageUrl}
                {...item}
            />)}
        </>
    );
}

export default Menu;